// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// Backward-compatibility re-export for consumers importing this public type from the internal path.
export { RadioButtonProps } from '../../../radio-button/interfaces';
